import React from 'react';

const Wallet = () => {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      {/* eslint-disable-next-line max-len */}
      <path d='M10 8.33333H10.0067M1 2.33333V11.6667C1 12.403 1.59695 13 2.33333 13H11.6667C12.403 13 13 12.403 13 11.6667V5C13 4.26362 12.403 3.66667 11.6667 3.66667L2.33333 3.66667C1.59695 3.66667 1 3.06971 1 2.33333ZM1 2.33333C1 1.59695 1.59695 1 2.33333 1H10.3333M10.3333 8.33333C10.3333 8.51743 10.1841 8.66667 10 8.66667C9.81591 8.66667 9.66667 8.51743 9.66667 8.33333C9.66667 8.14924 9.81591 8 10 8C10.1841 8 10.3333 8.14924 10.3333 8.33333Z' stroke='#7198A3' stroke-linecap='round' stroke-linejoin='round'/>
    </svg>
  );
};

export default Wallet;